import { html, mount, raw } from '../html.ts';
import { currentIntlLocale, t } from '../i18n.ts';
import { markdownToHtml } from '../markdown.ts';
import { publicPage, wireChrome } from '../components/chrome.ts';
import { brand, state } from '../state.ts';

export type LegalPage = 'impressum' | 'datenschutz';

async function fetchText(url: string): Promise<string | null> {
  try {
    const response = await fetch(url);
    return response.ok ? await response.text() : null;
  } catch {
    return null;
  }
}

/**
 * Imprint and privacy notice, public with or without a session. Texts come
 * from the deployment's legal directory (dist/web/legal, see build-web.ts);
 * English falls back to German when no translation exists.
 */
export async function renderLegal(root: HTMLElement, page: LegalPage): Promise<void> {
  const locale = currentIntlLocale().startsWith('en') ? 'en' : 'de';
  const markdown = (await fetchText(`/legal/${page}.${locale}.md`)) ?? (locale === 'en' ? await fetchText(`/legal/${page}.de.md`) : null);
  const back = state.me ? { href: '/', label: t('Zurück zur App') } : { href: '/login', label: t('Zur Anmeldung') };
  mount(
    root,
    publicPage(html`<div class="pma-legal">
      <header class="pma-legal__header">
        <a class="pma-brand" href="${back.href}"><img class="pma-brand-logo" src="${brand.logo}" alt="" width="32" height="32"><span><strong>${brand.shortName}</strong><small>${brand.tagline}</small></span></a>
        <a class="p-button p-button--ghost p-button--sm" href="${back.href}">${back.label}</a>
      </header>
      <main class="pma-legal__body" id="legal-main" tabindex="-1">
        <article class="pma-prose">${
          markdown
            ? raw(markdownToHtml(markdown))
            : html`<h1>${page === 'impressum' ? t('Impressum') : t('Datenschutz')}</h1><p>${t('Für diese Installation ist noch kein Text hinterlegt.')}</p>`
        }</article>
      </main>
    </div>`),
  );
  document.title = `${page === 'impressum' ? t('Impressum') : t('Datenschutz')} · ${brand.name}`;
  wireChrome(root);
  root.querySelector<HTMLElement>('#legal-main')?.focus({ preventScroll: true });
}
